module.exports = __webpack_public_path__ + "img/secure-pay-icon.a07f48cd.svg";